import React from 'react';
import BaseSimpleItemEditorForm from "../BaseSimplePage/BaseSimpleItemEditorForm";
import ArtistsItemForm from "../ArtistsPage/ArtistsItemForm";
import SuggestionBlock from "./SuggestionBlock";
import InfoBlock from "./InfoBlock";
import {allSuggestArtistRoles} from "../../data/Enums";

const ArtistSuggestionsItemFormStep3 = ({initData, controlRef}) => {

    return (
        <BaseSimpleItemEditorForm>
            <SuggestionBlock
                initData={initData}
            />
            <InfoBlock>
                Выполните внесение заявленного автора в базу Культураты
                <br/>
                Для внесения заполните форму ниже. Некоторые поля не обязательны.
                <br/>
                <br/>
                Если удалось успешно заполнить форму на добавление, то подтвердите добавление (кнопка <b>ДОБАВИТЬ&nbsp;АВТОРА</b>)
                <br/>
                <br/>
                Если не удалось найти данные по заявленному автору (невозможно заполнить форму), заявку можно удалить (кнопка <b>УДАЛИТЬ</b>) либо отложить (ничего пока не делать с ней)
            </InfoBlock>
            <ArtistsItemForm
                controlRef={controlRef}
                initMainRole={allSuggestArtistRoles.find(x => x.id === initData?.role) ? initData?.role : undefined}
                allowedRoles={allSuggestArtistRoles}
            />
        </BaseSimpleItemEditorForm>
    );
};

export default ArtistSuggestionsItemFormStep3;